module.exports = "/images/sellers-shield-white-img.svg?535bc32d744ffc295b3c8240567c9de5";